import script from "./homeWeb.vue?vue&type=script&setup=true&lang=js"
export * from "./homeWeb.vue?vue&type=script&setup=true&lang=js"

import "./homeWeb.vue?vue&type=style&index=0&id=331451c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-331451c6"]])

export default __exports__